export default "assets/images/logo-cheval-8e6440ca.svg";